<template lang="pug">
  div#appDemandas
    vue-progress-bar
    div(
      v-if="loader.status"
      v-loading="loader.status",
      :element-loading-text="loader.text",
      v-loading.fullscreen.lock="true"
    )
    header
      main-header(
        :hasNotificacaoModulo="true"
        :notificacao="false"
        :hasListagemModelo="false"
      )
    main.container
      side-menu
      .content
        el-card.default-card(:body-style="{ width: '100%' }" shadow="hover" :class="[userInterface.showMainCard ? 'container' : 'hide-card']")
          router-view
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MainHeader from '@/components/MainHeader'
import SideMenu from '@/components/SideMenu'
import PERFIL from '@/constants/perfil'

export default {
  components: {
    MainHeader,
    SideMenu
  },

  data () {
    return {
      PERFIL
    }
  },

  computed: {
    ...mapState({
      loader: state => state.loader,
      userInterface: state => state.userInterface
    })
  },

  methods: {
    ...mapActions({
      setMainCardVisibility: 'userInterface/setMainCardVisibility'
    })
  },

  watch: {
    $route (to, from) {
      this.setMainCardVisibility(true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

* {
  box-sizing: border-box;
  font-family: 'Ubuntu', sans-serif;
}

header {
  width: 100%;
  z-index: 5;
}

main.modal-open {
  overflow-x: hidden;
  position: relative;
  z-index: 8;
}

#appDemandas {
  width: 100%;
  height: 100%;

  /deep/ h1,
  /deep/ h2,
  /deep/ h3,
  /deep/ h4,
  /deep/ h5,
  /deep/ p {
    color: #424242;
  }

  /deep/ p {
    margin: 0 0 10px;
  }

  /deep/ main {
    height: calc(100vh - #{$header-size});
    width: 100%;
  }

  .container {
    display: flex;
    border-radius: 12px;
    width: 100%;
    min-height: 100%;
  }

  .content {
    width: 100%;
    padding: 20px 30px;
    overflow-y: scroll;
  }

  .hide-card {
    box-shadow: none;
    border: none;
    display: flex;
  }

  .el-card {
    min-height: 100%;
  }
}
</style>

<style>
.default-card {
  border-radius: 12px;
}

.container-listagem {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.container-listagem .el-card {
  height: 100%;
}

.el-select__tags-text {
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/MainPage.vue